import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpService2} from "../../../../shared/services/http-service-2.0/http2.0.service";
import {FormPostResult} from '../../../../shared/services/http-service-2.0/http.interface';
import {map} from "rxjs/operators";

@Injectable()
export class GlobalPopup2faService {
    constructor(protected httpService2: HttpService2) {
    }

    public save2faForm(email: string, code:string): Observable<FormPostResult>{
        let postValues: any = {
            'email':email,
            'code':code,
        };
        return this.httpService2.doFormPostRequest(`user-management/verify_email`, postValues, false).pipe(
            map((result) => {
                return result;
            })
        );
    }
}
